import React from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'

// UTILS
import commonUtils from 'utils/common'
import { Utils } from 'utils/Utils'
import { hasApplyAutocomplete } from 'utils/LocationUtil'
import I18n from 'i18n/i18n'
// CONTANTS
import { GMAPS_BROWSER_KEY, GMAPS_API_VERSION } from 'constants/appConstants'
// ASSETS
import {
  FLAG_VN_ICON,
  FLAG_TH_ICON,
  FLAG_PH_ICON,
  FLAG_ID_ICON,
  V2_LOGO_GREEN_TRANSPORTIFY,
  V2_LOGO_GREEN,
} from 'constants/imageConstants'
import locationUtils from 'utils/common/location'
import { closeLoading, hideLoading, openLoading } from 'assets/javascripts/webapp-v2/common'
import $ from 'jquery'
import { withNavigate } from 'hocs/withNavigate'
import areaApi from 'api/Area'

class SelectArea extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selectCountry: '',
      selectCity: {},
      // listCity: [],
      address: '',
      isValid: true,
      widthEachCharacter: 8,
      maxheightInput: 64,
      isFirstLoad: true,
      loadAutoCompleteListener: false,
    }

    this.countryGroup = (element, country) => {
      this[`countryGroup_${country}`] = element
    }

    this.tempInput = null
  }

  componentDidMount() {
    if (window.google && window.google.maps) {
      this.initLoaded()
    } else {
      // Trigger auto call google maps
      window.mapLoaded = () => {
        this.initLoaded()
      }

      if (window.google && window.google.maps) {
        window.mapLoaded()
      } else {
        const s = document.createElement('script')
        s.src = `https://maps.googleapis.com/maps/api/js?key=${GMAPS_BROWSER_KEY}&v=${GMAPS_API_VERSION}&libraries=places,geometry&callback=mapLoaded&language=${I18n.language}&channel=5`
        document.head.appendChild(s)
      }
    }
    hideLoading()
  }

  enableAutoComplete() {
    const { loadAutoCompleteListener } = this.state
    const { listCountry } = this.props
    const input = this.address
    if (loadAutoCompleteListener === false) {
      this.updateStatusAutoComplete(true)
      const autocompleteInput = new window.google.maps.places.Autocomplete(
        input, {
        fields: ['name', 'geometry.location', 'place_id', 'formatted_address', 'address_components'],
        componentRestrictions: { country: listCountry }
      }
      )
      window.google.maps.event.addListener(autocompleteInput, 'place_changed', () => {
        this.handlePlaceSelect(autocompleteInput)
        this.disableAutoComplete()
      })
    }
  }

  disableAutoComplete() {
    window.google.maps.event.clearInstanceListeners(this.address)
    this.updateStatusAutoComplete(false)
  }

  updateStatusAutoComplete(loadAutoCompleteListener) {
    this.setState({ loadAutoCompleteListener })
  }

  checkPositionAutoComplete() {
    const { isFirstLoad } = this.state
    const address = $(this.address).val()
    if (isEmpty(address)) {
      this.setState({
        isValid: true,
      })
    } else {
      setTimeout(() => {
        Promise.resolve(locationUtils.handleCallGeocodeAPI({ address }, (results) => {
          if (results) {
            const { lat, lng } = locationUtils.getDataResponse(results[0])
            const pacItem = document.getElementsByClassName('pac-item')
            if (lng && lat) {
              if (pacItem && pacItem.length > 0) {
                this.setState({
                  isValid: true,
                })
              } else if (isFirstLoad) {
                this.setState({
                  isValid: true,
                  isFirstLoad: false,
                })
              } else {
                this.setState({
                  isValid: false,
                })
              }
            }
            return
          }
          const pacItem = document.getElementsByClassName('pac-item')
          if (pacItem && pacItem.length > 0) {
            if (address.length > pacItem[0].innerText.length) {
              this.setState({
                isValid: false,
              })
            } else {
              this.setState({
                isValid: true,
              })
            }
          } else {
            this.setState({
              isValid: false,
            })
          }
        }))
      }, 250)
    }
  }

  initLoaded() {
    const addressName = $(this.address)
    const errorMessage = $(this.errorMessage)

    this.enableAutoComplete()
    addressName.on('keyup', (e) => {
      if (!hasApplyAutocomplete(e.keyCode)) {
        return
      }
      if (!['Enter', 'ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'].includes(e.key)) {
        this.enableAutoComplete()
        if (addressName.val() === '') {
          addressName.closest('.Input').removeClass('error')
          errorMessage.html('')
        }
      }
    })
  }

  detectMultipleLine(value = '') {
    const { maxheightInput, widthEachCharacter } = this.state
    const elem = document.getElementById('temp')
    const newValue = value || $(this.address).val()
    $(this.tempInput).val(newValue)

    const widthCharacterToCalculate = widthEachCharacter

    setTimeout(() => {
      const positionHeight = elem.scrollHeight - 20
      if (elem.scrollHeight > 0) {
        if (positionHeight > maxheightInput) {
          const fitWidth = parseInt(($(this.address).outerWidth() / widthCharacterToCalculate), 10)
          const isTruncate = fitWidth * 3 <= newValue.length
          const showDots = isTruncate ? 3 : 0
          const truncateValue = newValue.substring(0, fitWidth * 3 - showDots)
          $(this.address).val(`${truncateValue} ${isTruncate ? '...' : ''}`)
        }
        $(this.address).css({
          height: positionHeight,
          maxHeight: 54,
        })
      }
    }, 250)
  }

  handleChangeAddress(address, isSelected = false) {
    this.setState({
      address,
    }, () => {
      this.detectMultipleLine()
      if (!isSelected) {
        this.checkPositionAutoComplete(address)
      }
    })
  }

  handlePlaceSelect(autoComplete) {
    const input = $(this.address).val()
    const addressObject = autoComplete.getPlace() // get place from google api
    const addressDefault = {
      ...addressObject,
      formatted_full_address: input,
    }
    window.localStorage.setItem('addressDefault', JSON.stringify(addressDefault))
    const { address_components: addressComponents } = addressObject
    const cities = addressComponents.filter(address => address.types.includes('country'))[0].short_name
    this.handleChangeAddress(input, true)
    this.handleSelectCountry(cities)
    this.setState({
      isValid: true,
    })
  }

  handleKeyDown(e) {
    if (e.keyCode === 13) {
      e.preventDefault()
      const errorMessage = $(this.errorMessage)
      errorMessage.html('')
    }
  }

  updateSelectCity() {
    const { selectCountry } = this.state
    const { areas, listCountry } = this.props
    const cities = _.sortBy(_.filter(areas, { country_code: selectCountry }), 'name')
    const config = {
      countryGroup: this[`countryGroup_${selectCountry}`],
      selectCity: this.selectCityFlag,
      selectCityCountry: this.selectCityCountry,
      listCountry,
    }
    Utils.updateUISelectCity(_.size(cities) <= 7, config)
  }

  async handleSelectCountry(country) {
    openLoading()
    this.setState({ selectCountry: country })
    const currentAreaId = await areaApi.getCurrentArea({
      country_code: country,
      only: ['id']
    })
    if (currentAreaId) {
      const url = window.location.origin
      window.location.href = `${url}/?area_id=${currentAreaId}`
    }
    closeLoading()
  }

  renderAction() {
    const { selectCity } = this.state
    const { switchCountry, passingParams } = this.props

    return (
      <a
        href={`${switchCountry}?id=${selectCity.id}&${passingParams}`}
        rel="nofollow"
        data-method="put"
        className="green Button Button-Default Button-With-Border"
        id="select-country"
      >
        {I18n.t('webapp.action.next')}
      </a>
    )
  }


  renderCountry(country) {
    const { selectCountry } = this.state
    let iconFlag = ''
    let textFlag = ''
    switch (country) {
      case 'ID':
        iconFlag = FLAG_ID_ICON
        textFlag = 'Indonesia'
        break
      case 'TH':
        iconFlag = FLAG_TH_ICON
        textFlag = 'Thailand'
        break
      case 'PH':
        iconFlag = FLAG_PH_ICON
        textFlag = 'Philippines'
        break
      case 'VN':
        iconFlag = FLAG_VN_ICON
        textFlag = 'Vietnam'
        break
      default:
    }

    const isActive = selectCountry === country ? 'Active' : ''
    return (
      <div
        key={_.uniqueId()}
        className={`flex flex-index flex-center-justify ml5 mr5 cur-pointer ${isActive}`}
        onClick={() => this.handleSelectCountry(country)}
      >
        <div
          ref={countryGroup => this.countryGroup(countryGroup, country)}
          className="flex flex-column cur-pointer pl15 pr15 pt15 pb15"
        >
          <div className="mar15 flex flex-center">
            <img src={iconFlag} alt="deliveree icon" />
          </div>
          <span className="default-font default-color-icon default-medium-font">
            {textFlag}
          </span>
        </div>
      </div>
    )
  }

  render() {
    // const { selectCountry } = this.state
    const { backgroundImage, listCountry } = this.props
    const { address, isValid } = this.state
    const logo = commonUtils.isTransportify() ? V2_LOGO_GREEN_TRANSPORTIFY : V2_LOGO_GREEN
    return (
      <div
        className="fullscreen SelectCity"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div className="SelectCityBox">
          <div className="Box w-660">
            <div className="Box-Head">
              <div className="Logo">
                <img className="dlvr-full-logo" src={logo} alt="deliveree" />
              </div>
            </div>
            <div className="text-center font-bold">
              <p>
                {I18n.t('webapp.areas.enter_pickup')}
              </p>
            </div>
            <div className="dlvr-flex-center">
              <div className={`Input Input-Hover Multiple-Line Default-TextArea-Placeholder dlvr-address-input ${!isValid && address.length > 2 ? 'error' : ''}`}>
                <div className="Multiple-Line__Input flex flex-index">
                  <textarea
                    id="address-id"
                    ref={(ref) => { this.address = ref }}
                    maxLength={255}
                    className="Resize-None flex flex-index Radius-default mt10 pr10 pl10 pt0 pb10 location-address default-font sortable-enable"
                    placeholder={I18n.t('webapp.areas.enter_pickup_placholder')}
                    defaultValue={address}
                    onChange={event => this.handleChangeAddress(event.target.value)}
                    onKeyDown={event => this.handleKeyDown(event)}
                    style={{
                      height: 17,
                      resize: 'none',
                      overflow: 'hidden',
                    }}
                  />
                </div>
                <textarea
                  ref={(ref) => { this.tempInput = ref }}
                  className="Custom-Scroll-Group Resize-None flex flex-index Radius-default pt10 pr10 pb10 pl10 location-address default-font"
                  defaultValue={address}
                  id="temp"
                  style={{
                    height: 17,
                    resize: 'none',
                    opacity: 1,
                    position: 'absolute',
                    zIndex: -1,
                    left: 0,
                    width: 'calc(100% - 12px)',
                    fontSize: '15px',
                    overflowY: 'scroll',
                  }}
                />
              </div>
            </div>
            {!isValid && address.length > 2 && (
              <div className="dlvr-area-error-text">
                {I18n.t('webapp.new_booking.step_1.location_not_found')}
              </div>
            )}

            <div className="Box-Content pl25 pt15 pr25 pb25 flex-column Box-Sizing Border-Box">
              <div
                ref={(container) => { this.selectCityFlag = container }}
                className="flex SelectCity-Flag mar25 Custom-Scroll-Group-X"
              >
                {listCountry.map(country => (
                  this.renderCountry(country)
                ))}
              </div>
              {/* {selectCountry && this.renderCities()} */}
              <div className="hidden">
                {this.renderAction()}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

SelectArea.propTypes = {
  areas: PropTypes.instanceOf(Array).isRequired,
  backgroundImage: PropTypes.string.isRequired,
  switchCountry: PropTypes.string.isRequired,
  listCountry: PropTypes.instanceOf(Array).isRequired,
  passingParams: PropTypes.string.isRequired
}


export default  withNavigate(SelectArea)
